import React from 'react';

import { connect } from 'react-redux';
import { MdDelete } from "react-icons/md";
import { Col, Row, Button } from 'reactstrap';

//Scripts auxiliares:
import { rolesList, getCanDoBasedOnPermissions } from '../scripts/rolesDescription';

let UserRow = (props) => {
    if ((props.targetUser.is_admin && props.activeUser.is_admin) || !props.targetUser.is_admin) {
        return (
            <li>
                <Row>
                    <Col xs="1" md="1" lg="1" xl="1" >
                        <Button className="btn btn-default" data-tut="reactour__usersManagement.deleteUserButton"
                            hidden={!props.activeUser.is_admin} disabled={!props.activeUser.is_admin}
                            style={{ padding: "8px 10px", backgroundColor: "transparent", color: "#65615c", marginLeft: 5 }}
                            onClick={() => {
                                if (props.deleteUserFunction !== undefined) {
                                    props.deleteUserFunction(props.targetUser);
                                }
                            }}>
                            <MdDelete />
                        </Button>
                    </Col>

                    <Col xs="5" md="5" lg="5" xl="5">
                        <div style={{ marginTop: 10, textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden", cursor: "pointer" }}
                            title={getCanDoBasedOnPermissions(props.targetUser)}>
                            {props.targetUser.email}
                            <br />
                            <span className="text-muted">
                                <small>
                                    {getCanDoBasedOnPermissions(props.targetUser)}
                                </small>
                            </span>
                        </div>
                    </Col>

                    <Col className="text-right" xs="6" md="6" lg="6" xl="6">
                        <Row data-tut="reactour__usersManagement.usersRoleAsignationButton">
                            <Col className="text-center" xs="4" md="4" lg="4" xl="4" >
                                {/* Para el botón de admin: */}
                                <Button className="btn-round btn-icon" size="md" outline
                                    disabled={(props.activeUser.is_admin) ? false : true}
                                    color={(props.targetUser.is_admin) ? "success" : "danger"}
                                    title={(!props.targetUser.is_admin) ? "Convertir en administrador" : "Quitar acceso como administrador"}
                                    onClick={() => {
                                        if (props.updateUserFunction !== undefined) {
                                            props.updateUserFunction(props.targetUser, "is_admin");
                                        }
                                    }}>
                                    {rolesList[0].iconComponent}
                                </Button>
                            </Col>

                            <Col className="text-center" xs="4" md="4" lg="4" xl="4" >
                                {/* Para el botón de staff: */}
                                <Button className="btn-round btn-icon" size="md" outline
                                    color={(props.targetUser.is_staff) ? "success" : "danger"}
                                    disabled={(props.activeUser.is_admin || props.activeUser.is_staff) ? false : true}
                                    title={(!props.targetUser.is_staff) ? "Dar permisos de staff" : "Quitar permisos de staff"}
                                    onClick={() => {
                                        if (props.updateUserFunction !== undefined) {
                                            props.updateUserFunction(props.targetUser, "is_staff");
                                        }
                                    }}>
                                    {rolesList[1].iconComponent}
                                </Button>
                            </Col>

                            <Col className="text-center" xs="4" md="4" lg="4" xl="4" >
                                {/* Para el botón de user: */}
                                <Button className="btn-round btn-icon" size="md" outline
                                    color={(props.targetUser.is_active) ? "success" : "danger"}
                                    disabled={(props.activeUser.is_admin || props.activeUser.is_staff) ? false : true}
                                    title={(!props.targetUser.is_active) ? "Dar acceso a la plataforma" : "Quitar acceso a la plataforma"}
                                    onClick={() => {
                                        if (props.updateUserFunction !== undefined) {
                                            props.updateUserFunction(props.targetUser, "is_active");
                                        }
                                    }}>
                                    {rolesList[2].iconComponent}
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <hr></hr>
            </li>
        );
    }
    else {
        return (<React.Fragment />);
    }
}

const mapStateToProps = state => {
    return {
        activeUser: state.mainReducer.activeUser
    };
};

export default connect(mapStateToProps)(UserRow);